export default "__VITE_ASSET__BNhYe$RJ__"